<template>
    <div>
        <v-tabs v-model="tab" fixed-tabs>
            <v-tab>Tenants</v-tab>
            <v-tab>Permisos</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item transition="fade-transition">
                <TenantView/>
            </v-tab-item>
            <v-tab-item transition="fade-transition">
                <AuthBase/>
            </v-tab-item>
        </v-tabs-items>

        <DeleteDialog/>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import DeleteDialog from '@/components/DeleteDialog/DeleteDialog.vue';
import AuthBase from '@/components/DatabaseManagement/Auth/AuthBase.vue';
import TenantView from './TenantsView/TenantView.vue';

export default {
    name: 'DatabaseManagementBase',
    data: () => ({
        tab: 0,
    }),
    components: {
        DeleteDialog,
        AuthBase,
        TenantView
    },
    beforeCreate(){
        this.$store.dispatch('databaseManagement/auth/fetchGroups');
        this.$store.dispatch('databaseManagement/auth/fetchPermissions');
        this.$store.dispatch('tenantManagement/fetchTenants').then(() => {
            this.$store.commit('tenantManagement/isLoadingTenants', false);
        });
    },
    methods: {
		...mapActions('login', {
			checkGroupPermission: 'checkGroupPermission',
		}),
    },
};
</script>